import React, { useState, useContext, useEffect } from 'react';
// import './dashboard.css';
// import { AuthContext } from '../../../auth'
import { Redirect } from 'react-router-dom';
import Parse from 'parse'
// import { Link } from 'react-router-dom'
// import Navbar from '../layouts/navbar';
import swal from 'sweetalert';
import { AuthContext } from '../../auth';
import Counsellorsidebar from '../../components/counsellor/sidebar/sidebar';

const Members = () => {
    const [offline, setOffline] = useState([]);
    let [logedinuser, setLogedinuser] = useContext(AuthContext)


    useEffect(() => {
        const Offline = Parse.Object.extend("Offline");
        const query = new Parse.Query(Offline);
        // const familyStories = new FamilyStories();
        query.find()
            .then((member) => {

                setOffline(member);

            }, (error) => {
                console.log(error);
                swal("Oops!", "Seems like there is some problem with net", "error");

            })




    }, [])

    

    return (

        <React.Fragment>
            {(logedinuser == null) && (
                <Redirect to="/" />
            )}
            <Counsellorsidebar head="Appointments" />

            <div className="container" style={{ fontFamily: "'Open Sans', open-serif" }}>
                <div className="row">
                    <div className="col-12 text-center">
                        <h4 className="mb-0" style={{ color: "#65cdf0" }}>Appointments Pending</h4>
                        <div className="title-underline mb-2" style={{ background: "#65cdf0"}}></div>
                    </div>
                    <div className="col-12 patientprofiles">

                        {
                            offline.map(member => (
                                <div className="card">
                                    <div className="card-body">
                                        <div class="media" >
                                            <img class="mr-3" src="/assests/images/user.png" height="30" alt="" />
                                            <div class="media-body">
                                                <h5 class="my-0">{member.get("name")}</h5>
                                                Gender :{member.get("gender")}<br />
                                                Phone No :{member.get("phoneno")}<br />
                                                Doctor Needed :{member.get("doctor")}<br />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))

                        }

                    </div>
                </div>

            </div>
        </React.Fragment>
    )
}

export default Members;